export const handleSelectAll = (
  data: Array<{ id?: number }>,
  selectedRows: Set<number>,
  onRowSelect: (rowId: number) => void,
) => {
  const someSelected = data.some((row) =>
    selectedRows.has(row.id || data.indexOf(row)),
  );

  if (someSelected) {
    // Deselect all selected rows
    data.forEach((row) => {
      const rowId = row.id || data.indexOf(row);
      if (selectedRows.has(rowId)) {
        onRowSelect(rowId);
      }
    });
  } else {
    // Select all rows
    data.forEach((row) => {
      const rowId = row.id || data.indexOf(row);
      if (!selectedRows.has(rowId)) {
        onRowSelect(rowId);
      }
    });
  }
};
